'use client';

import { useEffect, useState } from 'react';

import { readStoredSession, SESSION_CHANGE_EVENT, writeStoredSession } from '@/services/sessionStorage';

/**
 * Lightweight session presence for chrome (header). Avoids pulling the login
 * API into every marketing page bundle.
 */
export function useSessionFlag() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const sync = () => setIsAuthenticated(readStoredSession() !== null);
    sync();
    window.addEventListener(SESSION_CHANGE_EVENT, sync);
    return () => window.removeEventListener(SESSION_CHANGE_EVENT, sync);
  }, []);

  const signOut = () => writeStoredSession(null);

  return { isAuthenticated, signOut };
}
